import { useEffect } from 'preact/hooks'
import { useSearchspringContext } from 'libs/searchspring/fetchers/provider'
import { SearchspringBlogSearchProvider } from 'libs/searchspring/fetchers/blog'
import { globalState } from '@/components/helpers/utils'
import { QuickSearchSuggestions } from 'libs/searchspring/components/quick-search/QuickSearchSuggestions'

function BlogSuggestionContent({ query, fallbackTitle, fallbackSuggestions, fallbackQuery }) {
  const { refine, results, isLoading } = useSearchspringContext()

  useEffect(() => {
    if (query) refine('query', query)
  }, [query])

  const hasBlogResults = !isLoading && results?.results?.length > 0

  if (!hasBlogResults) {
    return (
      <>
        <h3 className="h5">{fallbackTitle}</h3>
        <QuickSearchSuggestions query={fallbackQuery} defaultSuggestions={fallbackSuggestions} />
      </>
    )
  }

  return (
    <>
      <h3 className="h5">Blog Posts</h3>
      <div className="flex w-full flex-grow flex-col gap-y-1.25">
        {results.results.map((blog) => (
          <a href={blog.url} className="group w-fit" key={blog.id}>
            <span className="paragraph-b w-fit first-letter:capitalize link-fade">{blog.title}</span>
          </a>
        ))}
      </div>
    </>
  )
}

export function QuickSearchBlogSuggestions({ query, fallbackTitle, fallbackSuggestions, fallbackQuery }) {
  const blogSiteId = globalState?.siteIds?.blogs

  if (!blogSiteId || !query) {
    return (
      <>
        <h3 className="h5">{fallbackTitle}</h3>
        <QuickSearchSuggestions query={fallbackQuery} defaultSuggestions={fallbackSuggestions} />
      </>
    )
  }

  return (
    <SearchspringBlogSearchProvider category="blogs" runOnMount={false} resultsPerPage={4}>
      <BlogSuggestionContent
        query={query}
        fallbackTitle={fallbackTitle}
        fallbackSuggestions={fallbackSuggestions}
        fallbackQuery={fallbackQuery}
      />
    </SearchspringBlogSearchProvider>
  )
}
